import { render } from "./proformaCRUD.vue?vue&type=template&id=44dfef1c&scoped=true"
import script from "./proformaCRUD.vue?vue&type=script&lang=js"
export * from "./proformaCRUD.vue?vue&type=script&lang=js"

import "./proformaCRUD.vue?vue&type=style&index=0&id=44dfef1c&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44dfef1c"]])

export default __exports__